// test1062
(1062 && 0);
